import {
	doAjax, updateTableValue, initStitchesBackgroundColorListeners,
	changeStitchBackgroundColor, initRedPointLogic, fakeSelected, initColorSelect
} from './helper'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'

const initInteriorUpperCustomizing = () => {
	initColorSelect()
	loadAlreadyCustomizedOptions(() => {
		setNewDefaultColor();
	});

	//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
	let interiorUpperComponents = {
		DoorRail: 'stitchDoorRail',
		instrumentPanelCover: 'stitchInstrumentPanelCover',
		upperDashboard: 'stitchUpperDashboard'
	}

	for (const key in interiorUpperComponents) {
		const leatherComponent = key
		const stitchComponent = interiorUpperComponents[leatherComponent]
		//const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
		const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
		const callback = (component, colorCode) => {
			checkSiblings(component, colorCode)
			setImage(component, colorCode)
		}
		//initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
		initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
		//initStitchesBackgroundColorListeners(stitchComponentMatchingDotId)
	}
}

function setNewDefaultColor() {
	let defcolorCode = 8; // Fallback-Wert
    const hiddenInput = document.querySelector('input[type="hidden"][name="YFB"]');
    if (hiddenInput) {
        defcolorCode = parseInt(hiddenInput.value, 10) || defcolorCode;
		const stitchComponents = ['stitchUpperDashboard', 'stitchInstrumentPanelCover', 'stitchDoorRail']
		changeComponents(stitchComponents, defcolorCode);
    }    
}

/**Returns the DOT ID for the component on params */
function getDotIdWithComponent(component) {
	switch (component) {
		//case 'doorRail': return 'dot_tuerbrustung'
		case 'instrumentPanelCover': return 'dot_instru-abdeck'
		case 'upperDashboard': return 'dot_instru-oben'
		case 'stitchDoorRail': return 'dot_naht-tierbruestung'
		case 'stitchInstrumentPanelCover': return 'dot_naht-instru-abdeck'
		case 'stitchUpperDashboard': return 'dot_naht-instru-oben'
		default: break;
	}
}

function checkSiblings(component, colorCode) {
	const stitchComponents = ['stitchUpperDashboard', 'stitchInstrumentPanelCover', 'stitchDoorRail']
	const leatherComponents = ['upperDashboard', 'instrumentPanelCover']
	const isStitchElement = stitchComponents.indexOf(component) != -1
	if (areAllStitchesComponentsTheSameColor()) {
		//if (areAllLeatherComponentsDefaultColor() == true) {
			if (areAllStitchesComponentsDefaultColor() == true) {
				if (isStitchElement) {
					changeComponents(stitchComponents, colorCode)
				} else {
					changeComponents(leatherComponents, colorCode)
					changeComponents(stitchComponents, colorCode)

					changeStitchBackgroundColor(getDotIdWithComponent('stitchUpperDashboard'), colorCode)
					changeStitchBackgroundColor(getDotIdWithComponent('stitchInstrumentPanelCover'), colorCode)
					changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorRail'), colorCode)
				}
			} else if (areAllStitchesComponentsDefaultColor() == false && isStitchElement == false) {
				changeComponents(leatherComponents, colorCode)

				changeStitchBackgroundColor(getDotIdWithComponent('stitchUpperDashboard'), colorCode)
				changeStitchBackgroundColor(getDotIdWithComponent('stitchInstrumentPanelCover'), colorCode)
				changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorRail'), colorCode)
			}
		/*
		} else if (areAllLeatherComponentsDefaultColor() == false) {
			const selectedColor1 = document.querySelector('#upperDashboard td[color-code]').getAttribute('color-code')
			const selectedStitchColor1 = document.querySelector('#stitchUpperDashboard td[color-code]').getAttribute('color-code')
			if (isStitchElement && selectedColor1 == selectedStitchColor1) {
				changeComponents(stitchComponents, colorCode)
			}
		}
		*/
	}
}

/** This method will fake select the tile and change the components color for the components passed as parameter */
function changeComponents(components, colorCode) {
	components.forEach(component => {
		setImage(component, colorCode)
		fakeSelected(getDotIdWithComponent(component), colorCode)
	});
}

/** updates component state and replaces its images with new color */
function setImage(component, colorCode) {
	//change image on frontseat
	const imageSourceFront = aeo['paths']['interior_upper_front_view'][colorCode] + aeo['components']['interior_upper'][component]
	replaceImage(imageSourceFront, component + "Color", 'car_frontseat')

	//change image on backseat
	const isComponentOnBackseat = ['stitchDoorRail'].indexOf(component) != -1
	if (isComponentOnBackseat) {
		const imageSourceBack = aeo['paths']['interior_upper_back_view'][colorCode] + aeo['components']['interior_upper'][component]
		replaceImage(imageSourceBack, component + "Color", 'car_backseat')
	}

	//update table with new value
	updateTableValue(component, colorCode, 'interior-upper-components')

	//save component state
	doAjax({
		'interior_component': component,
		'color': colorCode,
		'src': imageSourceFront
	})
}

/*
function areAllLeatherComponentsTheSameColor() {
	const selectedColor1 = document.querySelector('#upperDashboard td[color-code]').getAttribute('color-code')
	const selectedColor2 = document.querySelector('#instrumentPanelCover td[color-code]').getAttribute('color-code')
	const selectedColor3 = document.querySelector('#doorRail td[color-code]').getAttribute('color-code')
	return selectedColor1 == selectedColor2 && selectedColor2 == selectedColor3
}
*/
/*
function areAllLeatherComponentsDefaultColor() {
	const selectedColor1 = document.querySelector('#upperDashboard td[color-code]').getAttribute('color-code')
	const firstComponentIsDefaultColor = selectedColor1 == aeo['default_color'].toString()
	return areAllLeatherComponentsTheSameColor() && firstComponentIsDefaultColor
}
*/

function areAllStitchesComponentsTheSameColor() {
	const selectedStitchColor1 = document.querySelector('#stitchUpperDashboard td[color-code]').getAttribute('color-code')
	const selectedStitchColor2 = document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
	const selectedStitchColor3 = document.querySelector('#stitchDoorRail td[color-code]').getAttribute('color-code')
	return selectedStitchColor1 == selectedStitchColor2 && selectedStitchColor2 == selectedStitchColor3
}

function areAllStitchesComponentsDefaultColor() {
	const selectedStitchColor1 = document.querySelector('#stitchUpperDashboard td[color-code]').getAttribute('color-code')
	const firstStitchComponentIsDefaultColor = selectedStitchColor1 == aeo['default_color'].toString()
	return areAllStitchesComponentsTheSameColor && firstStitchComponentIsDefaultColor
}


export { initInteriorUpperCustomizing };